import React from 'react';
import { IconStyles } from '../SelectIcon';

export const MarketingDigital = (props) => {
  const fillColors = {
    lightGrey: '#ebebeb',
    darkGrey: '#cbcbcb',
    blue: '#08605f',
  };
  return (
    <svg
      style={IconStyles}
      aria-label={props.label}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 231.7 310.6"
    >
      <path
        fill={fillColors.lightGrey}
        d="M142 306.3l24.3-7.3a1.6 1.6 0 0 0 1-2l-.4-1.7 7.4-2.2a17 17 0 1 0-1.2-3.8l-7.4 2.2-.5-1.7a1.6 1.6 0 0 0-2-1l-24.3 7.2a1.6 1.6 0 0 0-1.1 2l2.1 7.2a1.6 1.6 0 0 0 2 1zm44.2-32.4a13 13 0 1 1-8.8 16.2 13 13 0 0 1 8.8-16.2z"
      />
      <path
        fill={fillColors.blue}
        d="M141.2 309.8l15.8-20a2.3 2.3 0 0 0-.3-3l-.2-.3 5.3-6.8a2 2 0 0 0 .4-.8 22.4 22.4 0 1 0-4-3.2 2.2 2.2 0 0 0-.8.5L152 283l-.6-.5a2.3 2.3 0 0 0-3.2.4l-15.8 19.8a2.3 2.3 0 0 0 .4 3.2l5.2 4.2a2.3 2.3 0 0 0 3.2-.3zm19.7-60.4a16.8 16.8 0 1 1 2.7 23.6 16.8 16.8 0 0 1-2.7-23.6z"
      />
      <path
        fill={fillColors.darkGrey}
        d="M231.7 51.1a24.5 24.5 0 0 0-22.8-24.6C206.2 11 193-.5 177.7 0c-11.9.4-22 8-26.7 18.5a10.6 10.6 0 0 0-4.6-1c-6 .1-11 5.4-10.8 11.9a12.1 12.1 0 0 0 .4 2.8 22.6 22.6 0 0 0-17.5 22.9c.2 12.6 10 22.7 22 22.5l69.7-1v-.2a24.5 24.5 0 0 0 21.5-25.3z"
      />
      <path
        fill={fillColors.darkGrey}
        d="M227.3 47.2a22.6 22.6 0 0 0-21-22.7A29 29 0 0 0 177.4 0c-11 .4-20.2 7.3-24.7 17a9.5 9.5 0 0 0-4.2-.8c-5.6 0-10.1 5-10 11a11.3 11.3 0 0 0 .4 2.6A20.9 20.9 0 0 0 122.7 51c.2 11.7 9.3 21 20.3 20.9l64.5-1v-.1a22.7 22.7 0 0 0 19.8-23.5z"
      />
      <path
        fill={fillColors.blue}
        d="M188 34l-11.5-14-11.1 14.4h5.6l.7 42.7 11.4-.1-.7-42.9h5.7zM211.8 44.3l-8.7-10.5-8.4 10.8 4.3-.1.5 32.2 8.6-.2-.5-32.1 4.2-.1zM142 45.4l8.3-10.8 8.7 10.5-4.3.1.6 32.2-8.6.1-.5-32.2-4.3.1z"
      />
      <path
        fill={fillColors.lightGrey}
        d="M18.5 112a4 4 0 0 0 .2 2.9 3.3 3.3 0 0 0 2.1 2 14.5 14.5 0 0 0 3.6.6l-3.2-7.8a4.5 4.5 0 0 0-2.7 2.3z"
      />
      <path
        d="M32 125.3a16.4 16.4 0 0 0-3.6-.5l3.4 8.4a5.3 5.3 0 0 0 2.6-2.6 4.3 4.3 0 0 0 0-3.3 3.3 3.3 0 0 0-2.3-2z"
        fill="#fffcfa"
      />
      <path
        fill={fillColors.lightGrey}
        d="M17 97.6a27.2 27.2 0 1 0 35.4 14.9 27.2 27.2 0 0 0-35.5-15zm23.9 34.3a11.4 11.4 0 0 1-4.9 5.7l1.9 4.5-5 2L31 140a26.4 26.4 0 0 1-5 1.4 14 14 0 0 1-3.7.2l-.4-6.3a12.5 12.5 0 0 0 2.8 0 19.6 19.6 0 0 0 4-.9l-4-9.8-3.5-.2a12.8 12.8 0 0 1-3.5-1 9.5 9.5 0 0 1-3-2 10.1 10.1 0 0 1-2.2-3.5 9.6 9.6 0 0 1-.4-7.3 11.3 11.3 0 0 1 4.8-5.4l-1.8-4.4 5-2L22 103a21.5 21.5 0 0 1 4-1 23 23 0 0 1 3.3-.1l.4 6a17.6 17.6 0 0 0-5.4.7l3.7 9c1.1 0 2.3 0 3.6.2a13.6 13.6 0 0 1 3.5 1 10.2 10.2 0 0 1 3 1.9 9.3 9.3 0 0 1 2.3 3.4c1.2 3 1.4 5.6.6 7.8z"
      />
      <path
        fill={fillColors.lightGrey}
        d="M34.4 130.6a4.3 4.3 0 0 0 0-3.3 3.3 3.3 0 0 0-2.3-2 16.4 16.4 0 0 0-3.7-.5l3.4 8.4a5.3 5.3 0 0 0 2.6-2.6z"
      />
      <path
        fill={fillColors.lightGrey}
        d="M52.4 112.5a27.2 27.2 0 0 0-35.5-15l1 2.3 2.3-1 1.7 4.1a21.5 21.5 0 0 1 4-.9 23 23 0 0 1 3.3-.2l.4 6a17.6 17.6 0 0 0-5.4.7l3.6 9 3.7.3a13.6 13.6 0 0 1 3.5.9 10.2 10.2 0 0 1 3 2 9.3 9.3 0 0 1 2.3 3.3c1.2 3 1.4 5.6.5 7.9a11.4 11.4 0 0 1-4.8 5.6l1.8 4.5-2.4 1 2 4.9a27.2 27.2 0 0 0 15-35.4zM158.2 135.6c5 8.3 3.4 18.5-3.7 23s-17 1.2-22-7-3.5-18.6 3.6-23 17-1.2 22 7zM120.3 253c3.6 5.6 3 12.4-1.3 15l-8.4 5.2c-4.2 2.6-10.5 0-14-5.6l-28-45.2c-3.4-5.7-2.9-12.4 1.4-15l8.4-5.2c4.2-2.7 10.5-.2 14 5.5z"
      />
      <path
        fill={fillColors.darkGrey}
        d="M103.8 85.8c1.2 23-37.1 68.2-37.1 68.2l15.4 25 15.5 25s57.6-14 77.6-2.7l-35-58.2z"
      />
      <path
        fill={fillColors.blue}
        d="M181.3 197.3c1 1.7-.1 4.3-2.5 5.9-2.5 1.5-5.3 1.3-6.4-.4l-71-115c-1-1.8 0-4.4 2.5-5.9s5.3-1.3 6.4.4z"
      />
      <path
        d="M67.4 153l-27.7 17c-7.4 4.6-10 13.6-6 20.1l17 27.6c4 6.5 13.3 8.1 20.7 3.6L92.7 208l6.3-4z"
        fill="#fff"
      />
    </svg>
  );
};

export default MarketingDigital;



// WEBPACK FOOTER //
// ./src/components/UI/Img/SelectSVG/MarketingDigital.jsx